import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import reportWebVitals from './reportWebVitals';

const GOOGLE_OAUTH_CLIENT_ID = '625966657517-51lqo48uogfj7dv5jtjepkh5u6xkl4k2.apps.googleusercontent.com';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode> - Disabled to avoid double-render in development
    <ThemeProvider>
      <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    </ThemeProvider>
  // </React.StrictMode>
);

reportWebVitals();
